import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { SearchTextFieldStyles } from "@insite/content-library/Widgets/OrderHistory/SearchTextField";
import OrderHistoryIsBackordered from "@preferredMedical/Components/OrderHistoryIsBackordered/OrderHistoryIsBackordered";
import * as React from "react";

export const orderBackOrderStyles: SearchTextFieldStyles = {};
const styles = orderBackOrderStyles;

const OrderHistoryIsBackOrderedWidget: React.FunctionComponent<WidgetProps> = () => {
   
    return <OrderHistoryIsBackordered/>
};

const widgetModule: WidgetModule = {
    component: OrderHistoryIsBackOrderedWidget,
    definition: {
        group: "Order History",
        allowedContexts: ["OrderHistoryPage", "VmiOrderHistoryPage"],
        displayName: "Back Orders Checkbox",
    },
};

export default widgetModule;
